import { Component, Input, OnChanges, OnInit, SimpleChanges } from '@angular/core';
import { IndicatorsService } from '../../../../../services/indicators/indicators.service';
import { Observable } from 'rxjs/Observable';
import { isUndefined } from 'util';
import { Point } from '../../../../../models/pointWidget.model';

@Component({
  selector: 'app-transazioni-carta-indicator',
  templateUrl: './transazioni-carta-indicator.component.html',
  styleUrls: ['./transazioni-carta-indicator.component.css']
})
export class TransazioniCartaIndicatorComponent implements OnInit, OnChanges {

  @Input() data: any;
  @Input() detail: boolean;

  pointData: Point;
  penetration: Point;


  constructor(private indicatorService: IndicatorsService) {

  }

  ngOnInit() {
    if (isUndefined(this.data)) {
      return;
    }

    const requestName = ['TransazioniCarta'];
    if (this.detail) {
      requestName.push('TransazioniCartaPenetrazione');
    }

    const request = [];
    for (const name of requestName) {
      request.push(this.indicatorService.indicatorCalculation(name, this.data));
    }

    Observable.zip(...request).subscribe((res) => {
      this.pointData = res[0][0];
      this.penetration = res[0][1];
    });
  }

  ngOnChanges(changes: SimpleChanges) {
    if (!isUndefined(changes['data'].currentValue)) {
      this.ngOnInit();
    }
  }

}



// WEBPACK FOOTER //
// ./src/app/views/loyalty/widgets/value/transazioni-carta-indicator/transazioni-carta-indicator.component.ts